import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import styles from './select.module.css';

function MaterialSelect(props) {
    const { onChangeEvent, selectValue, items, placeholder, estilo } = props

    const onChange = (e) => {
        onChangeEvent(e)
    }

    return (

        <div className={`${styles.formGroup}`}>
            <FormControl fullWidth>

                <InputLabel id="demo-simple-select-label">Tipo documento</InputLabel>
                <Select onChange={onChange}
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    label="Tipo documento"
                    placeholder={placeholder}
                    value={selectValue}
                    error={estilo}
                >
                    {items.map((item, i) => {
                        return <MenuItem key={i} value={item.value}>{item.label}</MenuItem>
                    })}
                </Select>
            </FormControl>
        </div>
    );
}

export default MaterialSelect;